// extracted by mini-css-extract-plugin
module.exports = {"container":"Views_container__1hp_Q","containerHeadline":"Views_containerHeadline__2ErRZ","baseView":"Views_baseView__1JNvf"};